import { Link } from "react-router-dom";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Button,
} from "@headlessui/react";
import PaginationView from "components/table/Pagination";
import store from "redux/store";
import {
  SHOW_MODAL_COMPANY_CONNECT_WITH_CODE,
  SHOW_MODAL_COMPANY_PROVIDER_REQUEST,
} from "actions/types";
import { useTranslation } from "react-i18next";

export function Overview(props) {
  const { t, i18n } = useTranslation("productview");

  const changeCurrentCompany = (event, itemObj) => {
    event.preventDefault();
    const { setCurrentCompanyEvent } = props;
    setCurrentCompanyEvent(itemObj);
  };

  const connectCompanyByCode = (event) => {
    event.preventDefault();
    const { connectCompanyByCodeEvent } = props;
    store.dispatch({
      type: SHOW_MODAL_COMPANY_CONNECT_WITH_CODE,
      header: "Bedrijf koppelen",
      data: null,
      saveEvent: connectCompanyByCodeEvent,
    });
  };

  const companyProviderRequest = (event, company) => {
    event.preventDefault();
    store.dispatch({
      type: SHOW_MODAL_COMPANY_PROVIDER_REQUEST,
      header: "Aanvraag bedrijfverkoper profiel",
      data: company,
      saveEvent: null,
    });
  };

  return (
    <>
      <div className="mb-4 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
            Mijn bedrijven
          </h2>
        </div>
      </div>

      <dl className="grid grid-cols-1 gap-5 pt-8 sm:grid-cols-2 xl:grid-cols-2">
        <Link
          to="/company/add/"
          className="overflow-hidden relative px-4 pt-6 pb-12 bg-white border shadow-sm sm:px-6 sm:pt-7 group"
        >
          <dt>
            <div className="absolute p-3 rounded-full bg-primary/5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary size-6"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3 3H21V21H3V3ZM16 12.7502V11.2502H12.75L12.75 8.00759H11.25L11.25 11.2502H8.00736L8.00736 12.7502H11.25V15.9929H12.75V12.7502H16Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="ml-16 text-sm font-medium text-gray-900 truncate">
              Bedrijf aanmaken
            </p>
          </dt>
          <dd className="flex items-baseline pb-6 ml-16 sm:pb-7">
            <p className="text-sm text-gray-500">
              Wil je een bedrijf aanmaken om advertenties te kunnen plaatsen?
            </p>
            <div className="absolute inset-x-0 bottom-0 px-4 py-4 bg-gray-50 sm:px-6">
              <div className="text-sm">
                <div className="font-medium text-primary group-hover:underline">
                  Bedrijf aanmaken
                </div>
              </div>
            </div>
          </dd>
        </Link>

        <div
          onClick={(event) => connectCompanyByCode(event)}
          className="overflow-hidden relative px-4 pt-6 pb-12 bg-white border shadow-sm cursor-pointer sm:px-6 sm:pt-7 group"
        >
          <dt>
            <div className="absolute p-3 rounded-full bg-primary/5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary size-6"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.64125 9.29847C8.49624 7.44348 11.5038 7.44348 13.3588 9.29847L13.7019 9.64161C14.4775 10.4172 14.9295 11.3963 15.0562 12.4071L15.1494 13.1513L13.661 13.3378L13.5678 12.5936C13.4811 11.9019 13.1729 11.2339 12.6413 10.7023L12.2981 10.3591C11.0289 9.08993 8.97111 9.08992 7.70191 10.3591L4.35876 13.7023C3.08956 14.9715 3.08956 17.0293 4.35876 18.2985L4.70191 18.6416C5.97111 19.9108 8.02888 19.9108 9.29809 18.6416L9.99996 17.9397L11.0607 19.0003L10.3588 19.7023C8.50379 21.5572 5.49624 21.5573 3.64125 19.7023L3.2981 19.3591C1.44311 17.5041 1.44311 14.4966 3.2981 12.6416L6.64125 9.29847Z"
                  fill="currentColor"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.6412 5.29847C15.4962 3.44348 18.5037 3.44348 20.3587 5.29847L20.7019 5.64161C22.5568 7.4966 22.5568 10.5041 20.7019 12.3591L17.3587 15.7023C15.5037 17.5573 12.4962 17.5573 10.6412 15.7023L10.298 15.3591C9.52244 14.5835 9.07043 13.6044 8.94381 12.5936L8.85058 11.8494L10.3389 11.663L10.4322 12.4071C10.5188 13.0988 10.8271 13.7668 11.3587 14.2985L11.7019 14.6416C12.9711 15.9108 15.0288 15.9108 16.298 14.6416L19.6412 11.2985C20.9104 10.0293 20.9104 7.97148 19.6412 6.70228L19.298 6.35913C18.0288 5.08993 15.9711 5.08993 14.7019 6.35913L14.0001 7.06103L12.9393 6.00051L13.6412 5.29847Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="ml-16 text-sm font-medium text-gray-900 truncate">
              Bedrijf koppelen
            </p>
          </dt>
          <dd className="flex items-baseline pb-6 ml-16 sm:pb-7">
            <p className="text-sm text-gray-500">
              Heb je een code ontvangen om deel te kunnen nemen aan een bedrijf?
            </p>
            <div className="absolute inset-x-0 bottom-0 px-4 py-4 bg-gray-50 sm:px-6">
              <div className="text-sm">
                <div className="font-medium text-primary group-hover:underline">
                  Bedrijf koppelen
                </div>
              </div>
            </div>
          </dd>
        </div>
      </dl>

      <div className="flow-root mt-8">
        <div className="overflow-x-auto -mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div className="inline-block py-2 min-w-full align-middle sm:px-6 lg:px-8">
            <table className="min-w-full min-h-full divide-y divide-gray-300 h-fit">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    Bedrijfsnaam
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-sm font-semibold text-left text-gray-900 md:table-cell"
                  >
                    Rol
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-sm font-semibold text-left text-gray-900 md:table-cell"
                  >
                    Status
                  </th>
                  <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-0">
                    <span className="sr-only">Acties</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {props.items.map((item) => (
                  <tr key={item.id}>
                    <td className="py-4 pr-3 pl-4 text-sm whitespace-nowrap sm:pl-0">
                      <div className="flex items-center">
                        <div>
                          <p className="font-medium text-gray-900">
                            {item.name}
                          </p>
                          <p className="text-gray-500">{item.email1}</p>
                        </div>
                      </div>
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap md:table-cell">
                      <span className="inline-flex px-2 text-xs font-semibold leading-5 text-blue-700 bg-blue-50 rounded-full">
                        {item.userType}
                      </span>
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap md:table-cell">
                      <div>
                        {props.user &&
                          props.user.company &&
                          props.user.company.id === item.id && (
                            <span className="inline-flex gap-1 items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-50 rounded-full">
                              <span className="w-1.5 h-1.5 bg-green-600 rounded-full"></span>
                              Bedrijf is actief
                            </span>
                          )}
                      </div>
                    </td>
                    <td className="relative py-4 pr-4 pl-3 text-sm font-medium text-right whitespace-nowrap sm:pr-0">
                      <Menu
                        as="div"
                        className="inline-block relative text-left"
                      >
                        <div>
                          <MenuButton className="flex gap-2 items-center btn-secondary">
                            Meer
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="-mr-1 text-gray-400 size-4"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M20 9L12 17L4 9"
                                stroke="currentColor"
                                strokeWidth="2"
                              />
                            </svg>
                          </MenuButton>
                        </div>
                        <MenuItems
                          transition
                          className="absolute right-0 z-10 mt-2 w-56 origin-top-right  bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                          <div className="py-1">
                            {item && item.userType !== "WORKER" && (
                              <MenuItem>
                                <Link
                                  to="#"
                                  onClick={(event) =>
                                    companyProviderRequest(event, item)
                                  }
                                  className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="text-gray-500"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                  </svg>
                                  Aanvraag aanbieders account
                                </Link>
                              </MenuItem>
                            )}
                            {item && item.userType !== "WORKER" && (
                              <MenuItem>
                                <Link
                                  to={`/company/${item.id}/user`}
                                  className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="text-gray-500"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                                  </svg>
                                  Medewerkers beheren
                                </Link>
                              </MenuItem>
                            )}
                            {item && item.userType !== "WORKER" && (
                              <MenuItem>
                                <Link
                                  to={`/company/edit/${item.company_id}`}
                                  className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="text-gray-500"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                  Bedrijf bewerken
                                </Link>
                              </MenuItem>
                            )}
                            {!(
                              props.user &&
                              props.user.company &&
                              props.user.company.id === item.id
                            ) && (
                              <MenuItem>
                                <Button
                                  onClick={(event) =>
                                    changeCurrentCompany(event, item)
                                  }
                                  className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="text-gray-500"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
                                  </svg>
                                  Bedrijf actief maken
                                </Button>
                              </MenuItem>
                            )}
                          </div>
                        </MenuItems>
                      </Menu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PaginationView
        pagingEventHandler={props.pagingEventHandler}
        pagination={props.pagination}
      />
    </>
  );
}
